import React from 'react'

export default function About() {
  return (
    <div className='container pt-3 pb-3'>
      <h2 style={{color: "#bb790f"}}>ABOUT SMN</h2>
      <h4 className='mt-4'>Introduction to Sahibzada, Mujtaba & Naqvi <b style={{color: "#bb790f"}}>(SMN)</b></h4>
      <p style={{textAlign:"justify"}}>
        Sahibzada, Mujtaba & Naqvi <b style={{color: "#bb790f"}}>(SMN)</b> is in the initial stage of becoming one of the largest
        and most well reputed law firms in Pakistan highly regarded for its expertise in both
        contentious and non-contentious matters. The firm has 3 Partners and 4 Associates
        operating from the firm's offices in Lahore, Okara and Islamabad.
      </p>
      <h4>Evolution of the Firm</h4>
      <p style={{textAlign:"justify"}}>
        The firm was formed in 2018 as Haider, Bilal & Murtaza (HBM). The founding
        partners were Mr. Sahibzada Murtaza Ali, Haider Ali and Yasir Bashir. The firm’s
        name was changed to Sahibzada, Mujtaba & Naqvi <b style={{color: "#bb790f"}}>(SMN)</b> in the year 2024 when Mr.
        Haider Ali and Mr. Yasir Bashir left HBM and new partners joined the firm. New
        Partners included Mr. Ghulam Mujtaba Ilyas and Mr. Syed Zain Raza Naqvi.
      </p>
       <p style={{textAlign:"justify"}}>
        <b>Mr. Sahibzada Murtaza Ali</b> completed LL.B in the year 2014 and holds Post Graduate
        Diploma Taxation in the year 2023. He worked with the Ex-Law Minister Senator Dr.
        Babur Awan and handled his mainstream Lahore office as an Associate. Subsequently,
        he worked as an Associate in Cornelius, Lane & Mufti <b style={{color: "#bb790f"}}> (CLM)</b> (a top tier corporate law
        firm), until 2015. After which, he left CLM to established HBM and then SMN dealing
        mainly in legal, tax and financial consultancy. 
       </p>
       <p style={{textAlign:"justify"}}>
        <b>Mr. Ghulam Mujtaba Ilyas</b> is a versatile and performance driven lawyer, who
        completed LL.B in the year 2010 and LL.M in International Trade & Commercial Law
        from Durham University in the year 2012. He worked in <b style={{color: "#bb790f"}}> CLM </b> as a Senior Associate
        and for more than a decade until 2024. Subsequently, he joined hands with Mr.
        Sahibzada Murtaza Ali and formed <b style={{color: "#bb790f"}}>SMN</b>. 
       </p>
       <p style={{textAlign:"justify"}}>
        <b>Mr. Syed Zain Raza Naqvi</b> completed LL.B in the year 2015 and joined CLM as an
        Associate. He went to City University, London to pursue LL.M in International
        Banking & Finance Law and graduated in the year 2018 with distinction. After which,
        he again joined <b style={{color: "#bb790f"}}>CLM</b> and worked until 2024 as a Senior Associate. Subsequently, he
        joined hands with Mr. Sahibzada Murtaza Ali and Mr. Ghulam Mujtaba Ilyas and
        formed <b style={{color: "#bb790f"}}>SMN</b>. 
       </p>
       <p style={{textAlign:"justify"}}>
        The firm has kept up its healthy tradition of nurturing and promoting indigenous talent.
        Currently, <b style={{color: "#bb790f"}}>SMN</b> comprises of Associates namely <b>Mrs. Bushra Fatima, Mr. Hafiz
        Muhammad Zeeshan Ali, Mr. Babar Awan, Mr. Burhan-Ul-Islam and Mr. Ashhal
        Malik</b> who are practicing lawyers and managing the current litigation of the firm.
       </p>
    </div>
  )
}
